module.exports = __webpack_public_path__ + "f42641eed834f7b97a9499362c6c8855.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Italic-webfont.woff
// module id = 1082
// module chunks = 0